import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { DeveloperLink } from "@components/Game/Misc";
import { Awesome } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function DocumentsModerationScreen() {
    const { t } = useTranslation();
    const params = useParams();
    const header = t("Модерация УПД");
    return (
        <DefaultLayout>{params.id ? <Edit header={header} id={params.id} /> : <List header={header} />}</DefaultLayout>
    );
}

function List({ header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:moderation:documents:list"));

    if (!apiData) return;

    return (
        <ListingCard header={header}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Разработчик")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((obj) => (
                        <tr key={obj.id}>
                            <td>
                                <Link to={url_reverse("admin:moderation:documents:edit", { dev_id: obj.id })}>
                                    {obj.company_ru || obj.name}
                                </Link>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function Edit({ id, header }) {
    const { t } = useTranslation();
    const { apiData, setApiData, apiUrl } = useAppApi(url_reverse("api:moderation:documents:edit", { dev_id: id }));
    const [comment, setComment] = useState({});
    const [fastChoice, setFastChoice] = useState({});
    const { api_post } = useRequest();

    if (!apiData) return;

    const fastChoices = [];
    [...apiData.fast_choices].forEach((v) => {
        fastChoices.push({ value: v[0], label: v[1] });
    });

    const handleSubmit = (ev) => {
        const oid = parseInt(ev.target.value);
        const state = ev.target.name;
        const params = { id: oid, state, comment: comment[oid] };

        api_post(ev, apiUrl, {
            params,
            then: (resp) => {
                if (resp.status === "ok") {
                    const newApiData = { ...apiData };
                    newApiData.object_list = newApiData.object_list.filter((o) => o.id !== oid);
                    setApiData(newApiData);
                }
            },
        });
    };
    const getFile = (month, year) => {
        window.open(
            url_reverse("devs:edit", { dev_id: apiData.developer.id }) +
                "developer_document_file/" +
                `?month=${month}&year=${year}&signed=1`
        );
    };

    const cardHeader = (
        <>
            {header} &mdash; <DeveloperLink developer={apiData.developer} />
        </>
    );
    return (
        <ListingCard header={cardHeader}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th width="15%">{t("Документы")}</th>
                        <th width="25%">{t("Шаблон комментария")}</th>
                        <th width="25%">
                            {t("Комментарий для разработчика")} ({apiData.contact_lang})
                        </th>
                        <th width="20%" />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((obj) => (
                        <tr key={obj.id}>
                            <td>
                                {t("УПД")} {obj.month}.{obj.year}
                            </td>
                            <td>
                                <DevForm.Button
                                    variant="primary"
                                    size="lg"
                                    name="download"
                                    onClick={() => {
                                        getFile(obj.month, obj.year);
                                    }}
                                >
                                    <Awesome type="download" color="white" />
                                </DevForm.Button>
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                                <DevForm.Select
                                    name="fast_choice"
                                    choices={fastChoices}
                                    value={fastChoice[obj.id]}
                                    onChange={(ev) => {
                                        setFastChoice((prev) => ({ ...prev, [obj.id]: ev?.value }));
                                        setComment((prev) => ({ ...prev, [obj.id]: ev?.value }));
                                    }}
                                />
                            </td>
                            <td>
                                <DevForm.TextArea
                                    name="comment"
                                    rows={6}
                                    value={comment[obj.id]}
                                    onChange={(ev) => setComment((prev) => ({ ...prev, [obj.id]: ev.target.value }))}
                                />
                            </td>
                            <td>
                                {comment[obj.id] ? (
                                    <DevForm.Button
                                        variant="danger"
                                        name="declined"
                                        value={obj.id}
                                        onClick={handleSubmit}
                                    >
                                        {t("Отклонить")}
                                    </DevForm.Button>
                                ) : (
                                    <DevForm.Button
                                        variant="success"
                                        name="signed"
                                        value={obj.id}
                                        onClick={handleSubmit}
                                    >
                                        {t("Завершить проверку")}
                                    </DevForm.Button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}
